// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__1z94C","footer":"ChangeClinic_footer__BM-qI"};